import { createSelector } from 'reselect';

const getContentListData = state => {
  return state;
};

export const selectListData = createSelector(
  getContentListData,
  data => data.SmartListReducer
);
